import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DocMaskDirective } from './doc-mask.directive';
import { TextUtils } from '../../../resources/text.utils';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ DocMaskDirective ],
    exports: [ DocMaskDirective ],
    providers: [ TextUtils ],
})
export class DocMaskDirectiveModule {}
